export const SEARCH = "/search";
export const DASHBOARD = "/dashboard";
export const DELIVERIES = "/parcels";
export const PARCEL = `${DELIVERIES}/:parcelCode/:parcelAction?`;
export const WATCHLIST = "/watchlist";
export const EXPORT = "/export";
